import mutations from './mutations';
import actions from './actions';
import getters from "./getters";

export interface CountryData {
  name: string,
  dialCode: number,
  iso2: string
}
export interface CountryState {
    countries: {
        default: CountryData,
        optionGroups: [CountryData[], CountryData[]]
    },
    isInitialized: boolean
}

export const initialCountryState: CountryState = {
    countries: {
        default: {
            name: '',
            dialCode: 0,
            iso2: ''
        },
        optionGroups: [
            [],
            []
        ]
    },
    isInitialized: false
}

export default {
    namespaced: false,
    state: initialCountryState,
    mutations,
    actions,
    getters
}
